export default __webpack_public_path__ + "static/media/163a0670906a3d.acd3bfbc.jpg";